export const fr = {
  common: {
    welcome: "Bienvenue",
    loading: "Chargement...",
    error: "Erreur",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    add: "Ajouter",
    search: "Rechercher",
    back: "Retour",
  },
  auth: {
    signIn: "Se connecter",
    signOut: "Se déconnecter",
    email: "Email",
    password: "Mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    rememberMe: "Se souvenir pendant 30 jours",
    enterEmail: "Entrez votre adresse email",
    enterPassword: "Entrez votre mot de passe",
    welcomeBack: "Bienvenue ! Veuillez entrer vos identifiants.",
    invalidCredentials:
      "Échec de la connexion. Veuillez vérifier vos identifiants.",
  },
  navigation: {
    dashboard: "Tableau de bord",
    activityArea: "Zone d'activité",
    learningArea: "Zone d'apprentissage",
    transactionSummary: "Résumé des transactions",
    financialStatements: "États financiers",
    switchView: "Changer de vue",
    ameView: "Vue AME",
    userView: "Vue utilisateur",
  },
  cohort: {
    cohortOverview: "Aperçu de la cohorte",
    activeCohorts: "Cohortes actives",
    meetingPlatform: "Plateforme de réunion",
    trainer: "Formateur",
    language: "Langue",
    status: "Statut",
    created: "Créé",
    notSpecified: "Non spécifié",
    notAssigned: "Non assigné",
    totalParticipants: "Total des participants",
    sessionsScheduled: "Sessions programmées",
    clientsInvolved: "Clients impliqués",
    progress: "Progrès",
    participants: "Participants",
    addParticipant: "Ajouter un participant",
    editParticipant: "Modifier le participant",
    deleteParticipant: "Supprimer le participant",
    participantName: "Nom",
    participantEmail: "Email",
    participantJobTitle: "Titre du poste",
    client: "Client",
    noSessionsScheduled: "Aucune session programmée",
    dateTBD: "Date à déterminer",
    multipleClients: "Clients multiples",
    noClients: "Aucun client",
    unknownClient: "Client inconnu",
  },
  messages: {
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ceci ?",
    cannotBeUndone: "Cette action ne peut pas être annulée.",
    cohortLanguageNote: "Note : Cette cohorte est en",
  },
};
